import { ADOBE_BOARD_ID_KEY, ADOBE_SHARE_ID_KEY } from "../../../constants";

const getSharedBoardGlobalVars = () => [ADOBE_BOARD_ID_KEY, ADOBE_SHARE_ID_KEY];

export default getSharedBoardGlobalVars;
